const messages = {
  addNewCustomer: 'Add New Customer',
  allStyles: 'All styles by linesheet',
  buyerEmail: 'Buyer Email',
  connected: 'Connected',
  create: '+ Add',
  enterBuyerEmail: 'Enter Buyer Email',
  invalidEmail: 'Invalid email address',
  learnMore: 'Learn more',
  loadingRetailers: 'Loading retailers...',
  noConnection: 'No connection? ',
  noPriceTypeAvailable: 'No price type available',
  noPriceTypeAvailableForThisRetailer:
    'No price type available for this retailer',
  noRetailersFound: 'No retailers found',
  selectDoors: 'Door(s)',
  selectEvent: 'Event',
  selectLinesheet: 'Linesheet',
  selectOne: 'Select one',
  selectOrderPriceType: 'Price Type',
  selectOrderType: 'Order Type',
  selectOrderWarehouse: 'Warehouse',
  selectRetailer: 'Retailer',
  startOrder: 'Start an Order',
  startOrderAnyway:
    'Start your order anyway. Type a new customer into the search box. ',
  startTyping: 'Start typing to search...',
  unconnected: 'Unconnected',
}

export default messages
